import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { BUSINESS } from "@/data/business";

export default function Cancellation() {
  return (
    <LegalLayout
      title="Cancellation Policy"
      crumbName="Cancellation Policy"
      path="/cancellation-policy"
      description="Cancellation and rescheduling policy for JK House Cleaning services in Melbourne."
    >
      <p>
        We understand that plans change. This policy explains how to cancel or reschedule a booking with
        {" "}{BUSINESS.name}.
      </p>

      <LegalSection heading="Cancelling or rescheduling">
        <p>If you need to cancel or reschedule your clean, please let us know as early as possible by calling
          {" "}{BUSINESS.phoneDisplay}, emailing {BUSINESS.email}, or messaging us on WhatsApp. Advance notice
          helps us offer the slot to another customer and keep our schedule running smoothly.</p>
      </LegalSection>

      <LegalSection heading="Late cancellations">
        <p>Cancellations made at very short notice, or where our cleaner is unable to access the property on
          arrival, may affect scheduling. Any applicable fees will always be communicated to you clearly and
          agreed in advance as part of your booking.</p>
      </LegalSection>

      <LegalSection heading="Rescheduling by us">
        <p>Occasionally we may need to reschedule due to illness or unforeseen circumstances. If this happens, we
          will contact you as soon as possible to arrange a new time that suits you.</p>
      </LegalSection>

      <LegalSection heading="Access on the day">
        <p>Please ensure safe access is available at the agreed time and that pets are secured. If we are unable
          to access the property as arranged, we may not be able to complete the clean as scheduled.</p>
      </LegalSection>

      <LegalSection heading="Questions">
        <p>If you have any questions about cancelling or rescheduling, please contact us at {BUSINESS.email} or
          {" "}{BUSINESS.phoneDisplay}.</p>
      </LegalSection>
    </LegalLayout>
  );
}
